<template>
  <el-dialog class="live-preview d62df9a6" center :visible="isShow" destroy-on-close :show-close="false" :modal="true" :close-on-press-escape = 'false'>
    <!-- <div class="viewer" id="previewCesium"></div> -->
    <video-player class="viewer"  :options="playerOptions" id="video-player"/>
    <span slot="title" class="dialog-header">
      <span class="title">直播源</span>
      <Icon class="close" type="big" name="el-icon-close" @click.native="onClose"></Icon>
    </span>
  </el-dialog>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flvjs-es6'
import 'videojs-contrib-hls'
export default {
  name: 'livePreview',
  components: { videoPlayer },
  data () {
    return {
      isShow: false,
      playerOptions: {
        width: '1330',
        height: '748',
        preload: 'auto',
        sources: [{
          // type: 'video/x-flv', // flv格式（ios系统不支持）
          type: 'application/x-mpegURL', // hls（m3u8）格式
          src: ''
        }],
        autoplay: true,
        controls: false,
        techOrder: ['html5', 'flvjs'], // 播放flv格式需要的兼容顺序
        muted: true,
        notSupportedMessage: '此视频暂无法播放，请稍后再试'
      }
    }
  },
  mounted () {

  },
  destroyed () {
    this.destroy()
  },
  methods: {

    open ({ url }) {
      this.isShow = true
      if (url.indexOf('.m3u8') >= 0) {
        this.playerOptions.sources = [{
          type: 'application/x-mpegURL',
          src: url
        }]
      } else if (url.indexOf('.flv') >= 0) {
        this.playerOptions.sources = [{
          type: 'video/x-flv',
          src: url
        }]
      }
    },
    initViewer () {

    },

    // 清除数据
    clear () {
      this.playerOptions.sources = []
    },
    // 销毁
    destroy () {

    },
    onClose () {
      this.clear()
      this.isShow = false
    }
  }
}
</script>

<style lang="scss">
.live-preview.d62df9a6{
  overflow: hidden;
  .el-dialog{
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
    background: #3D3E40;
    border-radius: 6PX 6PX 6PX 6PX;
    width: 1360px;
    // height: 788px;
    margin: 50px auto !important
  }
  .el-dialog__header{
    background-color: $bg-color;
    padding: 2px;
    text-align: left;
    border-radius: 6PX 6PX 0 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .el-dialog__title{
      color: $font-colorf;
      font-size: $font-size16;
    }
  }
  .viewer {
    height: 748px;
    width: 1330px;
    margin: 15px auto;
    > .video-js {
      width: 100%;
      height: 100%;
    }
  }
  .el-dialog__body {
    background-color: $bg-color;
    padding: unset !important;
    border-radius: 0 0 6PX 6PX;
    height: 763px;
    .el-form-item__label {
      color: #999999;
    }
  }
  .dialog-header{
    height: 30px;
    line-height: 30px;
    .title{
      margin-left: 12px;
      color: $font-color9;
    }
    .value{
      color: $font-colorf;
      margin-right: 30px;
    }
    .close{
      float: right;
      margin-right: 1px;
    }
  }
}
</style>
